import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

export default function DisableConfirm({
  open,
  onOpenChange,
  onConfirm,
  entityLabel = "record",
  warningMessage,
  loading,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid="disable-confirm-dialog"
        className="rounded-sm border border-rose-200"
      >
        <AlertDialogHeader>
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-rose-50 text-rose-600">
              <AlertTriangle size={20} />
            </div>
            <div>
              <AlertDialogTitle className="text-rose-900">
                Disable this {entityLabel}?
              </AlertDialogTitle>
              <AlertDialogDescription className="mt-2 text-slate-600">
                {warningMessage ||
                  `This action performs a soft delete. The ${entityLabel} will be marked as disabled and remain in the database for compliance and audit purposes. You can re-enable it later.`}
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            data-testid="disable-confirm-cancel"
            className="rounded-sm"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="disable-confirm-confirm"
            disabled={loading}
            onClick={(e) => {
              e.preventDefault();
              onConfirm?.();
            }}
            className="rounded-sm bg-rose-600 text-white hover:bg-rose-700"
          >
            {loading ? "Disabling…" : "Yes, disable"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
